import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Trash2, Plus, Palette, AlertCircle, X } from "lucide-react";
import "./StatusModal.css"; 

export default function StatusModal({ open, onSelect, onClose }) {
  const { t } = useTranslation();
  const [customStatuses, setCustomStatuses] = useState([]);
  const [newName, setNewName] = useState("");
  const [selectedColor, setSelectedColor] = useState("#38bdf8");

  useEffect(() => {
    const saved = localStorage.getItem("custom_statuses");
    if (saved) setCustomStatuses(JSON.parse(saved));
  }, []);

  const handleAddStatus = () => {
    if (!newName.trim()) return;
    const newStatus = {
      id: Date.now(),
      label: newName,
      color: selectedColor
    };
    const updated = [...customStatuses, newStatus];
    setCustomStatuses(updated);
    localStorage.setItem("custom_statuses", JSON.stringify(updated));
    setNewName("");
  };

  const handleDeleteCustom = (e, id) => {
    e.stopPropagation();
    const updated = customStatuses.filter(s => s.id !== id);
    setCustomStatuses(updated);
    localStorage.setItem("custom_statuses", JSON.stringify(updated));
  };

  // --- SAUGIKLIS: X mygtukas ir Overlay ---
  const handleClose = () => {
    if (onClose) {
      onClose(); // Kviečiame tėvinę funkciją
    } else {
      onSelect(null); // Atsarginis variantas (jei onClose nepaduotas)
    }
  };

  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="status-modal-content" onClick={(e) => e.stopPropagation()}>
        
        {/* X MYGTUKAS */}
        <button className="modal-close-x" onClick={handleClose} type="button">
            <X size={24} />
        </button>

        <h3 className="modal-title">{t('select_status')}</h3>
        
        <div className="status-options-grid">
          <button className="st-btn work" onClick={() => onSelect("darbas")}>{t('work')}</button>
          <button className="st-btn off" onClick={() => onSelect("laisva")}>{t('off')}</button>
          <button className="st-btn sick" onClick={() => onSelect("serga")}>{t('sick')}</button>
          <button className="st-btn vacation" onClick={() => onSelect("atostogos")}>{t('vacation')}</button>
          <button className="st-btn holiday" onClick={() => onSelect("svente")}>{t('holiday')}</button>
          
          <button className="st-btn reset" onClick={() => onSelect("reset")}>{t('delete')}</button>

          {customStatuses.map(s => (
            <button 
              key={s.id} 
              className="st-btn custom" 
              style={{ border: `1px solid ${s.color}80`, boxShadow: `0 0 15px ${s.color}40` }}
              onClick={() => onSelect({ label: s.label, color: s.color, type: 'sonstiges' })}
            >
              {s.label}
              <div className="del-icon" onClick={(e) => handleDeleteCustom(e, s.id)}>
                <Trash2 size={14} />
              </div>
            </button>
          ))}
        </div>

        <div className="creation-box">
          <div className="warning-info">
            <AlertCircle size={14} />
            <span>{t('custom_status_warning')}</span>
          </div>

          <div className="creation-row">
            <div className="color-input-wrapper" style={{ backgroundColor: selectedColor }}>
              <input 
                type="color" 
                value={selectedColor} 
                onChange={(e) => setSelectedColor(e.target.value)} 
              />
              <Palette size={18} color="#000" />
            </div>

            <input 
              type="text" 
              className="status-name-input"
              placeholder={t('new_status_placeholder')} 
              value={newName} 
              onChange={(e) => setNewName(e.target.value)} 
            />

            <button className="add-status-btn" onClick={handleAddStatus}>
              <Plus size={20} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}